import { createFileRoute } from '@tanstack/react-router';
import { assertPublicToolsEnabled } from '@/lib/public-tools-feature';
import { TextToAudioDemoPage } from '@/components/astro/new-design-25/SEO/text-to-audio-demo-page';
import { hreflangLinks, seo } from '@/seo/seo';

export const Route = createFileRoute('/_marketing/_seo/text-to-audio')({
  beforeLoad: assertPublicToolsEnabled,
  head: () => ({
    meta: [
      ...seo({
        title:
          'Text to Audio Online — Free Text to Audio Converter with AI Voices | Listening',
        description:
          'Convert text to audio online with natural AI voices. Paste up to 10,000 characters and open a 24-hour read-along link with synced text, audio, and controls.',
      }),
    ],
    links: [...hreflangLinks('/text-to-audio')],
  }),
  component: () => (
    <TextToAudioDemoPage
      converterHeading='Text to audio'
      converterSubtitle='Paste your text and we will turn it into audio'
      conversionLabel='audio'
      downloadFileBaseName='listening-text-to-audio'
      faqDescription='Quick answers about the free text to audio converter.'
      faqTitle='Text to audio FAQ'
    />
  ),
});
